import { EventFrom } from 'xstate';

import assertEventType from 'common/bento/lib/assertEventType';
import { apolloClient } from 'common/graphql/clients';

import { ViewerTaxResidenciesFragmentDoc } from '../graphql/fragments/ViewerTaxResidencies.gql';
import { PersonalComplianceUpdateProfileDocument } from '../graphql/mutations/personalComplianceUpdateProfile.gql';
import { UpdateOnboardingTaxResidenciesDocument } from '../graphql/mutations/updateOnboardingTaxResidencies.gql';
import model, { Context } from './model';

const services = {
  sendProfile: (context: Context, event: EventFrom<typeof model>) => {
    assertEventType(event, 'SUBMIT');

    const { data } = event;

    return apolloClient.mutate({
      mutation: PersonalComplianceUpdateProfileDocument,
      variables: { input: data },
    });
  },

  sendTaxResidencies: (
    { getModuleData }: Context,
    event: EventFrom<typeof model>,
  ) => {
    assertEventType(event, 'SAVE_TAX_RESIDENCIES');

    const { data } = event;

    const applicationId = getModuleData().viewer.company?.companyProfileId;
    if (!applicationId) {
      throw new Error('Cannot save tax residencies without an applicationId');
    }

    return apolloClient.mutate({
      mutation: UpdateOnboardingTaxResidenciesDocument,
      // Update the cache manually otherwise the newly created
      // taxResidencies won’t be present under viewer and still be []
      update(cache, { data: mutationResult }) {
        cache.writeFragment({
          data: {
            __typename: 'Viewer',
            taxResidencies:
              mutationResult?.setApplicantTaxResidencies.taxResidencies ?? [],
            uid: getModuleData().viewer.uid,
          },
          fragment: ViewerTaxResidenciesFragmentDoc,
          id: cache.identify(getModuleData().viewer),
        });
      },
      variables: {
        input: {
          applicationId,
          taxResidencies: data,
        },
      },
    });
  },
};

export default services;
